export const Footer = () => <p>(c)2022 Jos Honig</p>;
